import apiService from '@/utils/api-client'
import config from "@/utils/appConfig"

export default {
  async getUserGuides(cntx, params) {
    return apiService.get(`guide`, { params, baseURL: config.VUE_APP_API_USER_GUIDE_BASE_URL })
      .then((data) => {
        return data
      })
      .catch((error) => {
        return error
      })
  },
  async addUserGuide(cntx, params) {
    return apiService.post(`guide`, params, { baseURL: config.VUE_APP_API_USER_GUIDE_BASE_URL })
      .then((data) => {
        return data
      })
      .catch((error) => {
        return error
      })
  },
  async updateUserGuide(cntx, params) {
    return apiService.patch(`guide`, params, { baseURL: config.VUE_APP_API_USER_GUIDE_BASE_URL })
      .then((data) => {
        return data
      })
      .catch((error) => {
        return error
      })
  },
  async deleteUserGuide(cntx, params) {
    return apiService.delete(`guide`, { baseURL: config.VUE_APP_API_USER_GUIDE_BASE_URL, data: params })
      .then((data) => {
        return data
      })
      .catch((error) => {
        return error
      })
  },
}
